<div class="overlay">
  <mat-card class="card" appearance="outlined">
    <mat-card-content class="card-content">
      <mat-progress-spinner
        mode="indeterminate"
        diameter="48"
        aria-hidden="true"
        class="spinner"
      ></mat-progress-spinner>
      <h1 class="headline">{{ 'handoff.headline' | transloco }}</h1>
      <p class="supporting">{{ 'handoff.supporting' | transloco }}</p>

      <div aria-live="polite" role="status" class="visually-hidden">
        {{ 'handoff.ariaLive' | transloco }}
      </div>

      @if (showFallback) {
        <a
          mat-flat-button
          color="primary"
          [href]="redirectUrl"
          class="fallback-link"
        >{{ 'handoff.fallback' | transloco }}</a>
      }
    </mat-card-content>
  </mat-card>
</div>
